module.exports = __webpack_public_path__ + "img/no-goods.b9c004a1.png";